import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

const url = 'active-offers/dashboard/annual-performance'

export default defineStore(
  'active-offers-annual-performance',
  storeModule.createStoreModule('active-offers-annual-performance', {
    fetchListURL: url,
    fetchFiltersURL: `${url}/filters`
  })
)
